export const AGREEMENTS_CACHE_KEY = 'get-agreements';
export const CONFIGURATIONS_CACHE_KEY = 'get-insurance-configurations';

export type TUpdateProfile = {
  birthDate: string;
};

export type TAgreementsResponse = {
  general: string;
  special: string;
};

export enum InsuranceConditionStatus {
  Open = 1,
  OpenWithCondition = 2,
  Close = 3,
}

export type TInsuranceCondition = {
  status: InsuranceConditionStatus;
  description: string;
  maximumAmount: number;
  minimumAmount: number;
  nonWorkingDaysCloseTime: string;
  nonWorkingDaysOpenTime: string;
  workingDaysCloseTime: string;
  workingDaysOpenTime: string;
};

export type TInsuranceConfigurationsResponse = {
  buyCondition: TInsuranceCondition;
  sellCondition: TInsuranceCondition;
};
